module.exports = __webpack_public_path__ + "img/Soby.17959907.png";